import devConfig from "./config.dev";

export const registrationConfig =
  window.Distinction && window.Distinction.registrationConfig
    ? window.Distinction.registrationConfig
    : devConfig;
